import { ESTADOS_CONTRATO } from "./constants";

export const EstadoContrato = ({ estado, testid }) => {
  const e = ESTADOS_CONTRATO[estado] || ESTADOS_CONTRATO.borrador;
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${e.cls}`} data-testid={testid}>{e.label}</span>;
};
